import { IFrameworkResource } from "../../frameworks";
import { IProfessionalSituationResource } from "../../professional-situations";
import { IHydraList } from "../../types";
import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ISkill, ISkillResource } from "../types";

export interface ISkillListQueryParameters
    extends IPaginateable, IOrderable<"officialTitle" | "shortTitle" | "createdAt" | "updatedAt" | "rank"> {
    filters?: {
        officialTitle?: string;
        shortTitle?: string;
        frameworks?: RelationalFilter<IFrameworkResource>;
        professionalSituations?: RelationalFilter<IProfessionalSituationResource>;
        skills?: RelationalFilter<ISkillResource>;
        by_learner?: RelationalFilter<IUserResource>;
    };
}

export type ISkillListQueryResult = IHydraList<ISkill>;

const mapFilters = (filters: ISkillListQueryParameters["filters"]) => {
    const { officialTitle, shortTitle, frameworks, professionalSituations, skills, by_learner } = filters ?? {};
    return {
        officialTitle,
        shortTitle,
        by_learner: mapRelationalFilter(by_learner),
        "frameworks.uuid": mapRelationalFilter(frameworks),
        "professionalSituations.uuid": mapRelationalFilter(professionalSituations),
        uuid: mapRelationalFilter(skills),
    };
};

export const skillListQuery: IApiQueryFunction<ISkillListQueryParameters> = ({ pagination, order, filters }) => {
    return {
        method: "GET",
        url: `/skills${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useSkillListQuery = createApiQueryHook<ISkillListQueryParameters, ISkillListQueryResult>(skillListQuery);
